import pythonApiClient from './pythonBaseApi';

const trabajadoresMantenimientoApi = {
  listar(params) {
    return pythonApiClient.get('/mantenimientos/hoteleria/trabajadores', { params });
  },
  obtener(id) {
    return pythonApiClient.get(`/mantenimientos/hoteleria/trabajadores/${id}`);
  },
  actualizar(id, body) {
    return pythonApiClient.put(`/mantenimientos/hoteleria/trabajadores/${id}`, body);
  },
  eliminar(id) {
    return pythonApiClient.delete(`/mantenimientos/hoteleria/trabajadores/${id}`);
  },
};

export default trabajadoresMantenimientoApi;
